import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { User } from '../../../../../models/User';

declare var jQuery;

@Component({
  selector: 'app-traffic-overview',
  templateUrl: './app-traffic-overview.html',
  styleUrls: ['./app-traffic-overview.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTrafficOverview implements OnInit {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];

  tooltipTemplate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
  hasAdSpendPermission: boolean;

  constructor(public _userService: User) {}

  ngOnInit() {
    this.hasAdSpendPermission = this._userService.appAdSpendEnabled();
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
